import http from "./http";

export default {
  // Settings
  getSettings() {
    return http.get("/printnode/settings");
  },
  updateSetting(key, value) {
    return http.put("/printnode/settings", { key, value });
  },

  // Connection test
  testConnection() {
    return http.get("/printnode/test_connection");
  },

  // Sync computers & printers from PrintNode
  sync() {
    return http.post("/printnode/sync");
  },

  // Printers
  getPrinters() {
    return http.get("/printnode/printers");
  },
  setRolePrinter(printerId, role) {
    return http.put(`/printnode/default/${printerId}`, { role });
  },
  removeRolePrinter(printerId, role) {
    return http.delete(`/printnode/default/${printerId}`, { params: { role } });
  },
  setPaperSize(printerId, paperSize) {
    return http.put(`/printnode/paper_size/${printerId}`, {
      paper_size: paperSize
    });
  },

  // Computers
  getComputers() {
    return http.get("/printnode/computers");
  },

  // Print
  testPrint(printnodePrinterId) {
    return http.post("/printnode/test_print", {
      printnode_printer_id: printnodePrinterId
    });
  },
  print(payload) {
    return http.post("/printnode/print", payload);
  },
  printOrder(orderUuid) {
    return http.post("/printnode/print_order", { order_uuid: orderUuid });
  },
  printLabel(shipmentUuid) {
    return http.post("/printnode/print_label", {
      shipment_uuid: shipmentUuid
    });
  },

  // Jobs
  getJobs() {
    return http.get("/printnode/jobs");
  }
};
